// Import source styles
import '../scss/app.scss';

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

import { setupOptimizedScrollThrottle } from "./modules/_throttle.mjs";
import { validate } from './modules/_validate.mjs';
import { navigationSlider } from "./modules/_carousels.mjs";
import { stappenSlider } from "./modules/_carousels.mjs";
import { scrollSpy } from "./modules/_scrollspy.mjs";

// Make Fancybox globally available
window.Fancybox = Fancybox;

document.addEventListener("DOMContentLoaded", function () {
    AOS.init({startEvent: 'load', disable: 'mobile'});
    validate();
    navigationSlider();
    //stappenSlider();
    scrollSpy();
    setupOptimizedScrollThrottle();

    const whiteboard = document.getElementById('whiteboard');
    const whiteboardButton = document.getElementById('whiteboard-toggler');
    whiteboardButton.addEventListener('click', function () {
        if (whiteboard.classList.contains('hide')) {
            whiteboard.classList.remove('hide');
        } else {
            whiteboard.classList.add('hide');
        }
    });

});


